import debounce from "debounce";
import { Util } from "pdfjs-dist/build/pdf";
import createStore from "astrid-helpers/src/createStore";
import { getPdf, onPdf } from "./pdf";
import { getSize } from "./size";
export const [getNumPages, setNumPages, useNumPages] = createStore(0);
export const [getPages, setPages, usePages, onPages] = createStore([]);
const updatePages = debounce(() => {
  const pdf = getPdf();
  const size = getSize();
  if (!pdf) return;
  setNumPages(pdf.numPages);
  if (!size) return;
  Promise.all(Array.apply(null, Array(pdf.numPages)).map(async (v, i) => {
    const page = await pdf.getPage(i + 1);
    const textContent = await page.getTextContent({
      normalizeWhitespace: true,
      disableCombineTextItems: true
    });
    const viewport = page.getViewport({
      scale: 1
    });
    const {
      width,
      height,
      transform
    } = viewport;
    return {
      page: page.pageNumber,
      items: textContent.items.map(item => {
        const tx = Util.transform(transform, item.transform);
        return {
          dir: item.dir,
          text: item.str,
          rects: [{
            left: tx[4] / width,
            top: (tx[5] - item.transform[0]) / height,
            width: item.width / width,
            height: item.height / height
          }]
        };
      }),
      text: textContent.items.reduce((text, item) => text + item.str, "").replace(/-/g, "")
    };
  })).then(setPages);
}, 500);
onPdf(() => {
  updatePages();
  return () => {
    setPages([]);
    setNumPages(0);
  };
});
//# sourceMappingURL=pages.js.map